import { render } from "./RiProdoffering180.vue?vue&type=template&id=6b5a6ba2"
import script from "./RiProdoffering180.vue?vue&type=script&lang=js"
export * from "./RiProdoffering180.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering180.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b5a6ba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b5a6ba2', __exports__)) {
    api.reload('6b5a6ba2', __exports__)
  }
  
  module.hot.accept("./RiProdoffering180.vue?vue&type=template&id=6b5a6ba2", () => {
    api.rerender('6b5a6ba2', render)
  })

}


export default __exports__